import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { fmtFecha, fmtHora } from "@/lib/format";
import { toApiLocalTimestamp, toLocalInput } from "@/lib/fichajeUi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function CorreccionFichajeDialog({ item, onClose, onSuccess }) {
  const [timestamp, setTimestamp] = useState(item?.timestamp ? toLocalInput(item.timestamp) : "");
  const [motivo, setMotivo] = useState("");
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (item?.timestamp) setTimestamp(toLocalInput(item.timestamp));
    setMotivo("");
  }, [item]);

  const enviar = async () => {
    if (!item?.fichaje_id) {
      toast.error("No se encontró el fichaje asociado");
      return;
    }
    if (!motivo.trim() || motivo.trim().length < 3) {
      toast.error("Indica el motivo de la corrección");
      return;
    }
    setEnviando(true);
    try {
      await api.post("/fichajes/solicitar-correccion", {
        fichaje_id: item.fichaje_id,
        timestamp: toApiLocalTimestamp(timestamp),
        motivo: motivo.trim(),
      });
      toast.success("Corrección enviada al encargado para su aprobación");
      onSuccess?.();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open={!!item} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="correccion-fichaje-dialog">
        <DialogHeader>
          <DialogTitle>Solicitar corrección del picado</DialogTitle>
        </DialogHeader>
        {item && (
          <div className="space-y-3 text-sm">
            <p className="text-zinc-600">
              Registro actual: <strong>{fmtFecha(item.fecha || item.timestamp)} {item.hora || fmtHora(item.timestamp)}</strong>
            </p>
            <div className="space-y-1.5">
              <Label>Hora correcta propuesta</Label>
              <Input type="datetime-local" value={timestamp} onChange={(e) => setTimestamp(e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label>Motivo</Label>
              <Textarea value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Explica por qué debe corregirse" rows={3} />
            </div>
            <p className="rounded-lg bg-indigo-50 px-3 py-2 text-xs text-indigo-800">
              Tu encargado revisará la solicitud y, si la aprueba, se actualizará el fichaje automáticamente.
            </p>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={enviar} disabled={enviando} className="bg-indigo-600 hover:bg-indigo-700">
            {enviando ? "Enviando…" : "Enviar corrección"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
